import { I18nTypes } from '../../App/types';

export const getDisplayRuleElementId = (displayRuleId: I18nTypes, displayRuleIndexes?: number[]): string => {
  if (!displayRuleIndexes || displayRuleIndexes.length === 0) {
    return displayRuleId;
  }
  return `${displayRuleId}_${displayRuleIndexes.join('_')}`;
};
